import { useQuery } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';

const useGetDiagnosticModes = () => {
  const {
    data = [],
    isFetching,
    isError,
  } = useQuery(
    ['diagnostic-modes'],
    async () => {
      const response = await instance.get(`/nexa/diagnostic-templates/modes`);
      return response.data;
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity, // Never consider data stale
      notifyOnChangeProps: ['isFetching', 'isError', 'data'],
    },
  );

  return { data, isFetching, isError };
};

export default useGetDiagnosticModes;
